import React from 'react'
import LatestBlogs from './LatestBlogs'
import { LatestAiBox, LatestBlogsTypographyTitle } from '../../styles/homeStyled'
import { Container } from '@mui/material'

const LatestAiBlog = ({posts}) => {
    // I must have two separate classes so it my pagination dots would load two times.
    const paginationClass = 'ai-pagination'
    return (
        <LatestAiBox>
            <Container component='section' maxWidth="lg" sx={{ position: 'relative' }}>
                <LatestBlogsTypographyTitle variant="body2" >
                    Latest AI Blog
                </LatestBlogsTypographyTitle>
                <LatestBlogs paginationClass={paginationClass} posts={posts} category='ai-blog' />
            </Container>
        </LatestAiBox>
    )
}

export default LatestAiBlog